/* eslint-disable @typescript-eslint/naming-convention */
export const PRODUCT_GRID_LOTTIE_LOCATION_INDEX = 5
export const PRODUCT_GRID_PRODUCTS_PER_LOTTIE = 4

export const PRODUCT_GRID_DESKTOP_WIDTH_THRESHOLD = 1104

export const ARTICLES_LIMIT_LCDH_PAGE = 4
